(ns machtfit.stepchall.my-team
  (:require [machtfit.core :as machtfit]
            [machtfit.format :as format]
            [machtfit.startpage.api-events :as api-events]
            [machtfit.stepchall.api :as api]
            [machtfit.stepchall.charts :as charts]
            [machtfit.stepchall.countdown :as countdown]
            [machtfit.stepchall.message :as message]
            [machtfit.stepchall.modal :as modal]
            [machtfit.stepchall.share-team :as share-team]
            [machtfit.stepchall.subs :as subs]
            [machtfit.stepchall.team-members :as team-members]
            [machtfit.translation :refer [tr tr-with-place-holders t]]
            [re-frame.core :as rf]))

(defn- team-interaction [{:keys [text cta on-click danger?]}]
  [:div.sc_interaction-box {:class (when danger? "warning")}
   [:p text]
   [:a.sc_button.sc_button-inline {:on-click on-click} cta]])

(rf/reg-sub ::competition-ended?
  :<- [:get [:clock :current-server-time]]
  :<- [:get [:stepchall :challenge-end]]

  (fn [[current-server-time challenge-end] _]
    (>= current-server-time challenge-end)))

(rf/reg-event-db ::leave-team-clicked
  (fn [db _]
    (assoc-in db [:ui :stepchall :confirm-action] :leave-team)))

(defn- leave-team []
  [team-interaction {:text (tr "Möchtest du dein Team verlassen? Du kannst einem neuen Team beitreten oder Zuschauer werden.")
                     :cta (tr "Team verlassen")
                     :danger? true
                     :on-click #(rf/dispatch [::leave-team-clicked])}])

(rf/reg-event-db ::deactivate-participation-clicked
  (fn [db _]
    (assoc-in db [:ui :stepchall :confirm-action] :deactivate-participation)))

(defn- deactivate-participation []
  [team-interaction {:text (tr "Wenn du deine Wertung beendest, kannst du dies 24 Stunden lang rückgängig machen. Danach unterstützt du dein Team nicht mehr.")
                     :cta (tr "Wertung beenden")
                     :danger? true
                     :on-click #(rf/dispatch [::deactivate-participation-clicked])}])

(rf/reg-event-fx ::activate-participation-clicked
  (fn [{:keys [db]} _]
    {:post (api/request db
                        {:function :stepchall-activate-participation
                         :params {}})}))

(rf/reg-sub ::can-reactivate-until
  :<- [:get [:stepchall :participant :deactivated-at]]

  (fn [deactivated-at _]
    ((fnil + 0) deactivated-at (* 24 60 60))))

(defn- activate-participation []
  (let [countdown (countdown/countdown {:from @(rf/subscribe [:get [:clock :current-server-time]])
                                        :until @(rf/subscribe [::can-reactivate-until])})]
    [team-interaction {:text (tr-with-place-holders
                              "Du hast noch {countdown}, um doch in der Wertung zu bleiben. Andernfalls unterstützt du dein Team nicht weiter."
                              {"countdown" countdown})
                       :cta (tr "Wertung doch nicht beenden")
                       :danger? false
                       :on-click #(rf/dispatch [::activate-participation-clicked])}]))

(rf/reg-event-db ::decline-modal-clicked
  (fn [db _]
    (update-in db [:ui :stepchall] dissoc :confirm-action)))

(rf/reg-event-fx ::confirm-leave-team-clicked
  (fn [{:keys [db]} _]
    {:post (api/request db
                        {:function :stepchall-leave-team
                         :params {}})
     :db (update-in db [:ui :stepchall] dissoc :confirm-action)}))

(defn- leave-team-modal []
  [modal/modal {:img-src (machtfit/static "img/stepchall/leave-team.svg")
                :title (tr "Team verlassen?")
                :content [(fn []
                            (let [current-time @(rf/subscribe [:get [:clock :current-server-time]])
                                  team-building-end @(rf/subscribe [:get [:stepchall :team-building-end]])
                                  team-name (t @(rf/subscribe [:get [:stepchall :team :name]]))]
                              [:p (tr-with-place-holders "Möchtest du dein Team {team-name} wirklich verlassen? Bereits erfasste {main-units} werden in ein neues Team mitgenommen. Du hast noch {countdown} Zeit, einem neuen Team beizutreten."
                                                         {"team-name" team-name
                                                          "countdown" (countdown/countdown {:from current-time
                                                                                            :until team-building-end})
                                                          "main-units" (t @(rf/subscribe [:get [:stepchall :main-unit :plural]]))})]))]
                :button-group [{:text (tr "Doch nicht")
                                :on-click #(rf/dispatch [::decline-modal-clicked])}
                               {:text (tr "Team verlassen")
                                :style "sc_button-inline warning"
                                :on-click #(rf/dispatch [::confirm-leave-team-clicked])}]
                :close-button {:on-click #(rf/dispatch [::decline-modal-clicked])}
                :help-attr {:context :leave-team}}])

(rf/reg-event-fx ::confirm-deactivate-participation-clicked
  (fn [{:keys [db]} _]
    {:post (api/request db
                        {:function :stepchall-deactivate-participation
                         :params {}})
     :db (update-in db [:ui :stepchall] dissoc :confirm-action)}))

(defn- deactivate-participation-modal []
  [modal/modal {:img-src (machtfit/static "img/stepchall/stop-counting.svg")
                :title (tr "Wertung beenden?")
                :content [:p (tr "Wenn du deine Wertung beendest, gehen dieser und alle folgenden Tage nicht in die Team-Wertung und die Gesamtbewertung mit ein.")]
                :button-group [{:text (tr "Doch nicht")
                                :on-click #(rf/dispatch [::decline-modal-clicked])}
                               {:text (tr "Wertung beenden")
                                :style "sc_button-inline warning"
                                :on-click #(rf/dispatch [::confirm-deactivate-participation-clicked])}]
                :close-button {:on-click #(rf/dispatch [::decline-modal-clicked])}
                :help-attr {:context :exit-team-scoring}}])

(rf/reg-sub ::team-interaction
  :<- [::subs/in-team-building-phase?]
  :<- [:get [:stepchall :participant :deactivated-at]]
  :<- [::competition-ended?]
  :<- [:get [:clock :current-server-time]]
  :<- [::can-reactivate-until]

  (fn [[in-team-building-phase? deactivated-at competition-ended? current-server-time can-reactivate-until] _]
    (cond
      in-team-building-phase? :leave-team
      (and (nil? deactivated-at)
           (not competition-ended?)) :deactivate-participation
      (< current-server-time can-reactivate-until) :activate-participation)))

(defn my-team []
  (let [{:keys [member-count]} @(rf/subscribe [:get [:stepchall :team]])
        in-team-building-phase? @(rf/subscribe [::subs/in-team-building-phase?])
        min-team-size @(rf/subscribe [:get [:stepchall :min-team-size]])]
    [:<>
     [:div
      (when (and in-team-building-phase? (< member-count min-team-size))
        [:div.sc_container
         [share-team/team-minimum-size-warning]])
      [:div.sc_content
       [:div.sc_vertical-center.sc_justify-center
        [:h2.sc_headline
         (tr "Mein Team")]]
       [:div.sc_subtitle (str (format/decimal @(rf/subscribe [:get [:stepchall :team :step-counts :total]]))
                              " / "
                              (format/decimal @(rf/subscribe [:get [:stepchall :goal]])) " " (t @(rf/subscribe [:get [:stepchall :main-unit :plural]])))]
       [:div.sc_my-steps
        [charts/charts-container]
        [share-team/share-team]
        [team-members/team-members]
        (case @(rf/subscribe [::team-interaction])
          :leave-team [leave-team]
          :deactivate-participation [deactivate-participation]
          :activate-participation [activate-participation]
          nil)

        [message/send-message-modal]]]]
     (case @(rf/subscribe [:get [:ui :stepchall :confirm-action]])
       :leave-team [leave-team-modal]
       :deactivate-participation [deactivate-participation-modal]
       nil)]))

(rf/reg-event-fx ::navigate-to-stepchall-my-team
  (fn [{:keys [db]} [_ {:keys [show-members?]}]]
    (-> {:db db}
        (assoc-in [:db :ui :page] {:id :stepchall
                                   :subpage :my-team})
        (assoc :scroll-to (if show-members?
                            {:frame :app-frame
                             :subject ".sc_team-members"
                             :mode :center}
                            {:frame :app-frame
                             :mode :page-top}))
        (api-events/api-requests-on-stepchall-event))))
